import type {ReactElement} from 'react';
import {useState} from 'react';
import type {TimeZone} from 'timezones-list';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItem3} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {SearchBar, SearchBarSize} from '@Components/search-bar';
import {filterTimeZones} from '@Components/event-wizard/timezone/timezone.helper';
import {getTimezoneDisplayLabel} from '@Components/event-wizard/timezone-content/timezone-content.helper';
import type {CountdownTimezoneListProps} from './countdown-timezone-list.types';
import styles from './countdown-timezone-list.module.scss';

export function CountdownTimezoneList({selected, onSelect, className = ''}: CountdownTimezoneListProps): ReactElement {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const timezones = filterTimeZones(searchTerm);

  function handleSelect(tzCode?: string): void {
    const match = timezones.find((timezone) => timezone.tzCode === tzCode);
    if (match) {
      onSelect(match);
    }
  }

  function getItems(): ControlledListItem3[] {
    return timezones.map((timezone: TimeZone) => ({
      id: timezone.tzCode,
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_3,
      text: getTimezoneDisplayLabel(timezone, true),
      isSelected: timezone.tzCode === selected.tzCode,
    }));
  }

  return (
    <div className={`${styles.content} ${className}`}>
      <SearchBar
        className={styles.search}
        size={SearchBarSize.SMALL}
        placeholder={window.i18next.t('pmwjs_search_time_zones')}
        allowEmptySearch
        onInput={(value: string): void => {
          setSearchTerm(value);
        }}
      />
      <ControlledList items={getItems()} onClick={handleSelect} />
    </div>
  );
}
